import { types } from 'mobx-state-tree'

import { AuthModel } from './AuthModel'
import { UserModel } from './UserModel'

export const RootModel = types
  .model('Root', {
    auth: types.optional(AuthModel, {}),
    user: types.optional(UserModel, {}),
  })
  .views(self => ({
    get persistedModels() {
      return [self.auth, self.user]
    },
  }))
